// HOOKS
import useModal from "../../../../hooks/other/useModal.other.hook";
import useColumns from "../../../../hooks/other/useColumns.other.hook";
// COMPONETNS
import InfoTag from "../../infoTag.infoBar.component";
import CloseButton from "../../../buttons/close.button";
import TableModal from "../../../modals/table.modal.component";
import ResizableHeader from "../../../tables/customizableTable/headers/resizable.header";

const DEFAULT_CLASSNAMES = {
  container:
    "px-2 py-1 hover:bg-secondary rounded-full font-ubuntuRegular active:font-bold active:text-white active:skew-y-0 hover:skew-y-3 cursor-pointer flex flex-row items-center justify-center h-full w-full",
  tr: "",
};

const filterHiddenColumns = (column) => column?.show;

const SelectedInfoTag = ({
  handleClear = () => {},
  handleSelect = () => {},
  handleSelectAll = () => {},
  selectedData = [],
  defaultColumns = [],
  classNames = DEFAULT_CLASSNAMES,
  label = "",
}) => {
  const { columns, handleResize } = useColumns(defaultColumns);
  const { isShowing, open, close } = useModal();

  return (
    <>
      <InfoTag>
        <div
          onClick={open}
          className={classNames.container || DEFAULT_CLASSNAMES.container}
        >
          {label}
        </div>
        <CloseButton onClose={handleClear} size="sm" />
      </InfoTag>
      <TableModal
        isShowing={isShowing}
        handleClose={close}
        tableProps={{
          header: (
            <tr>
              <th className="max-w-[45px]">
                <input
                  className="checked:accent-primary w-[45px]"
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={selectedData?.length === 0 ? false : true}
                />
              </th>
              {columns?.filter(filterHiddenColumns)?.map((column) => (
                <ResizableHeader
                  key={column?.id}
                  column={column}
                  handleResize={handleResize}
                >
                  {column?.label}
                </ResizableHeader>
              ))}
            </tr>
          ),
          body: selectedData?.map((data, index) => (
            <tr
              key={index}
              className={`${index % 2 ? "bg-slate-100" : "bg-slate-300"}`}
            >
              {
                <td>
                  <input
                    data-_id={data?._id}
                    type="checkbox"
                    name="select-open-part-order"
                    checked={true}
                    className="checked:accent-primary h-full mx-4 my-5 items-center"
                    onChange={handleSelect}
                  />
                </td>
              }
              {columns.filter(filterHiddenColumns).map((column, index) => (
                <td
                  key={`${column}-${index}`}
                  className="text-black text-center font-ubuntuRegular"
                >
                  {column?.type === "multiSelect"
                    ? data?.[column?.id]?.map((item) => item?.name).join(",")
                    : data?.[column?.id]}
                </td>
              ))}
            </tr>
          )),
        }}
      />
    </>
  );
};

export default SelectedInfoTag;
